import React from 'react';
import ReactDOM from 'react-dom/client';

import BufferOptionsView from 'buffers/BufferOptionsView';
import AaSequenceAlignmentTabState from 'molbio/tabstates/AaSequenceAlignmentTabState';
import {renderToDOM, unmountRootsAsync} from 'redux-stores/ReduxDOMRender';

import AaSequenceAlignmentToolbar from './AaSequenceAlignmentToolbar';
import {renderAlignmentSVG} from './AaSequenceAlignmentUtil';

export default class AaSequenceAlignmentTabOptionsView extends BufferOptionsView<AaSequenceAlignmentTabState> {
  reactRoot: ReactDOM.Root | null = null;
  _boundRenderAlignmentSVG!: () => Promise<SVGSVGElement>;

  override initialize(): void {
    this._boundRenderAlignmentSVG = this._renderAlignmentSVG.bind(this);
    this.listenTo(this.model.get('selection'), 'change:start change:end', this.render.bind(this));
  }

  _renderAlignmentSVG(): Promise<SVGSVGElement> {
    return renderAlignmentSVG(this.model);
  }

  override render(): this {
    const visibilityOptions = this.model.get('visibilityOptions');
    const alignment = this.model.get('alignment');
    const selection = this.model.get('selection');
    const selectionProps = {
      start: selection ? selection.start() : 0,
      end: selection ? selection.end() : null,
    };
    let element;
    if (alignment) {
      element = (
        <AaSequenceAlignmentToolbar
          visibilityOptions={visibilityOptions}
          alignment={alignment}
          renderAlignmentSVG={this._boundRenderAlignmentSVG}
          selection={selectionProps}
        />
      );
    } else {
      element = <div />;
    }
    this.reactRoot = renderToDOM(element, this.el, this.reactRoot);
    return this;
  }

  override removeAsync(callback: () => void): this {
    unmountRootsAsync([this.reactRoot], () => {
      this.reactRoot = null;
      super.remove();
      callback();
    });
    return this;
  }
}
